// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateGeneralForm{background-color:#fff}", "",{"version":3,"sources":["webpack://./src/components/UsecaseCreate/Forms/CreateGeneralForm/CreateGeneralForm.scss"],"names":[],"mappings":"AACA,mBACI,qBAAA","sourcesContent":["@import '../../../../global/styles/variables.scss';\n.CreateGeneralForm {\n    background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
